import { useLaunchParams } from '@tma.js/sdk-react';

export const usePlatform = () => {
    const lp = useLaunchParams(true);
    return ['macos', 'ios'].includes(lp.tgWebAppPlatform) ? 'ios' : 'base';
};
